module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/breeno-icon.5f6ba0a6.webp";